import { HistoryContainer } from './views/history/HistoryContainer'
export default HistoryContainer
